import React from "react";
import { PageHeader, ToolTiles, Section } from "@/components/dashboard/DashboardPrimitives";
import ReportsPanel from "@/components/dashboard/ReportsPanel";

export default function ClassTeacherDashboard({ user }) {
  return (
    <>
      <PageHeader
        user={user}
        subtitle="View aggregated growth data for your class. Individual children's medical records are parent-controlled and never shown at the teacher level."
      />
      <Section title="Your class" testid="teacher-context">
        <div className="rounded-xl bg-[#0E1A3A] border border-slate-800 p-6">
          <dl className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 text-sm">
            <div><dt className="text-slate-500 text-xs uppercase">School</dt><dd className="text-slate-100 mt-1">{user.school_name || user.school_id || "—"}</dd></div>
            <div><dt className="text-slate-500 text-xs uppercase">Class / Grade</dt><dd className="text-slate-100 mt-1">{user.class_grade || "—"}</dd></div>
          </dl>
        </div>
      </Section>

      <ToolTiles />

      <Section title="Class reports overview" description="Aggregate counts only — individual records are not visible." testid="teacher-reports-section">
        <ReportsPanel userRole={user.role} />
      </Section>
    </>
  );
}
